import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import Spinner from "../../components/Shared/Spinner";
import TrashIcon from "../../components/Icons/TrashIcon";
import DeleteModal from "../../components/Shared/DeleteModal";
import { useState } from "react";
import { toast } from "react-toastify";
import { DeleteMockupExam } from "../../api/Certificates/DeleteMockup";
import { MockupExamsByCertificateId } from "../../api/Certificates/MockupExamsByCertificateId";
const DeleteMockup = () => {
    const { id } = useParams();
    const certificateId = id || "";
    const [isMCQOpen, setIsMCQOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<string | null>(null);

    const { data: QuizsDTO, isLoading: isQuizLoading } = useQuery({
        queryFn: () => MockupExamsByCertificateId(certificateId),
        queryKey: ["certificates", certificateId],
        staleTime: 0,
        refetchInterval: 0,
    });
    const quizs = QuizsDTO?.data;
    if (isQuizLoading)
        return (
            <div className="min-h-[80vh] flex items-center justify-center">
                <Spinner />
            </div>
        );
    if (!quizs) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <p>No data available</p>
            </div>
        );
    }
    const handleDeleteMockup = async (id: string) => {
        await DeleteMockupExam(id);
        toast.success("Mockup exam deleted successfully");
    };


    return (
        <div>
            <div className="flex justify-between items-center py-7">
                <h1 className="text-burntBlack font-bold text-[32px]">All Mockups</h1>
            </div>
            <div>
                {quizs && quizs.map((mcq, index: number) => (
                    <div key={mcq.id} className="flex justify-between items-center py-4 border-b border-gray-200 relative">
                        <span>Mockup {index + 1}. {mcq.title}</span>
                        <button
                            onClick={() => {
                                setSelectedId(mcq.id);
                                setIsMCQOpen(true);
                            }}
                            className="bg-red-500 text-white px-4 py-2 rounded flex items-center gap-2 duration-300 transition-all hover:bg-red-900 absolute right-0"
                        >
                            Delete <TrashIcon />
                        </button>
                        <DeleteModal
                            isOpen={isMCQOpen}
                            setIsOpen={setIsMCQOpen}
                            mutationFn={() => handleDeleteMockup(selectedId!)}
                            itemId={selectedId!}
                            queryKey="certificates"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DeleteMockup;
